import { Component, HostListener, EventEmitter } from '@angular/core';
import { AuthService } from 'src/shared/auth.service';
import { CommonService } from 'src/shared/common.service';
import { Platform } from '@angular/cdk/platform';
import { PlatformLocation } from '@angular/common';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ConfirmationDialog } from 'src/components/confirmation-dialog/confirmation-dialog.component';
import { Router, NavigationStart, ActivatedRoute } from '@angular/router';
import { ApplicantLoanComponent } from './applicant-loan/applicant-loan.component';
import { ApiService } from 'src/shared/api.service';
import { AtomicService } from 'src/shared/atomic.service';
import * as _ from 'lodash';
import { FUNDDEPOSIT_INPUTREQUEST } from 'src/models/fund-deposit.model';
import { NmaoWfService } from 'src/shared/nmao-wf.service';
import { ScrollStrategy, ScrollStrategyOptions } from '@angular/cdk/overlay';
(window as any).global = window;
import * as  $ from 'jquery';
import { CookieService } from 'ngx-cookie-service';

const ATTRIBUTION_COOKIE_NAME = 'skyone_attribution';
const ATTRIBUTION_SUPPORTED_VERSIONS = ['1.0'];
const ATTRIBUTION_ID_PATTERN = /^[A-Za-z0-9_-]{1,100}$/;
const ATTRIBUTION_TOUCH_COUNT_PATTERN = /^[0-9]{1,10}$/;
const ATTRIBUTION_MAX_TEXT_LENGTH = 200;
const ATTRIBUTION_MAX_URL_LENGTH = 500;
const ATTRIBUTION_MAX_AGE_DAYS = 35;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'so-client-app';
  public static isDesktop: Boolean;
  public static nmaoConfigs: any ={};
  public static QualificationAssessment =[];
  MOBILE_WIDTH = 768;
  public static scrollStrategy: ScrollStrategy;
  public static direct_deposit = true;
  public static direct_deposit_shown_failed = false;
  public static direct_deposit_answer="";
  public static direct_deposit_subtype="";
  public static direct_deposit_subtypes = [];
  public static paycheck_perks_answer="";
  public static paycheck_perks_round_up_answer="";
  public static  xaAppSubmittedSuccess: EventEmitter<string> = new  EventEmitter<string>();

  public static docuSignCallbacked: EventEmitter<any> = new EventEmitter<any>();
  public static bbString = '';

  public static showPayCheckPerkOnUI = null;
  public static showRoundUpOnUI = null;
  isCoBrand = false;
  ApplicantLoanComponent = ApplicantLoanComponent;

  logger = function()
  {
      var oldConsoleLog = null;
      var pub = {} as any;

      pub.enableLogger =  function enableLogger() 
                          {
                              if(oldConsoleLog == null)
                                  return;

                              window['console']['log'] = oldConsoleLog;
                          };

      pub.disableLogger = function disableLogger()
                          {
                              oldConsoleLog = console.log;
                              window['console']['log'] = function() {};
                          };

      return pub;
  }();

  public constructor(private authService: AuthService,
    private readonly sso: ScrollStrategyOptions, 
    location: PlatformLocation,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private apiService: ApiService,
    private atomicLog: AtomicService,
    private nmaoWfService: NmaoWfService,
    public commonService: CommonService, private pl: Platform,
    private cookieService : CookieService) {
      this.readAttributionCookie();
      this.cookieService.deleteAll('/')

      AppComponent.scrollStrategy = this.sso.block(); // block background scroll when modal is open
    this.initializeApp();
    location.onPopState(() => {

      // var r = confirm("You pressed a Back button! Are you sure?!");

      let dialogRef = this.dialog.open(ConfirmationDialog, {
        disableClose: true,
        scrollStrategy:  AppComponent.scrollStrategy,
        data: {
          confirmMessage: "If you proceed then your form won't be saved and you will have to refill the form.",
        },
        panelClass: AppComponent.isDesktop ? 'col-md-6' : 'full-screen',
        autoFocus: false,
        hasBackdrop: true,
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
                  // Call Back button programmatically as per user confirmation.
                  history.go(-2);
                  // Uncomment below line to redirect to the previous page instead.
                  // window.location.href = document.referrer // Note: IE11 is not supporting this.
        }else{
          history.pushState(null, null, window.location.pathname);
        }
        history.pushState(null, null, window.location.pathname);
      });
      
    });
    this.activatedRoute.queryParams.subscribe(params => {
      ApplicantLoanComponent.refChannel = this.commonService.attributionData?.campaign_id || params['ref'] || ApplicantLoanComponent.refChannel;
      this.apiService.getChannelByCurrentUri(ApplicantLoanComponent.refChannel).subscribe(r=>{
        if(r){
          ApplicantLoanComponent.currentChannel = r;
          this.isCoBrand = r.channelTypeId == 3;
        }
      })
    });
   

  }

  ngAfterViewInit() {
    setTimeout(() => {
      AppComponent.bbString = (document.getElementById("bbInput") as any).value;
      if (!AppComponent.bbString) { // testing if snarejs not loaded ?
        setTimeout(() => {
          AppComponent.bbString = (document.getElementById("bbInput") as any).value;
        }, 2500);
      }
    }, 500);
  }
  

  public static get paycheck_perks_selected(): boolean{
    if(AppComponent.paycheck_perks_answer.toUpperCase() == 'NO'){
      return false;
    }
    if(AppComponent.paycheck_perks_answer.toUpperCase() == 'YES'){
      return true;
    }
    return null;
  }

  public static get paycheck_perks_round_up_selected(): boolean{
    if(AppComponent.paycheck_perks_round_up_answer.toUpperCase() == 'NO'){
      return false;
    }
    if(AppComponent.paycheck_perks_round_up_answer.toUpperCase() == 'YES'){
      return true;
    }
    return null;
  }

  public static init_direct_deposit_subtypes(products){
    var productTypesCheck = ['savings','checking']
    AppComponent.direct_deposit_subtypes =  _.map(
      _.filter(products, pr=> {return pr.isDDAQualified && productTypesCheck.indexOf(pr.productType.toLowerCase()) > -1 })
      , i=>{
      return {name: i.name, value:i.name}
    })

    AppComponent.direct_deposit_subtype = AppComponent.direct_deposit_subtypes[0].name;
  }

  private sanitizeAttributionText(value: any, maxLength: number): string | undefined {
    if (typeof value !== 'string' || value.length === 0 || value.length > maxLength) {
      return undefined;
    }
    return value;
  }

  private sanitizeAttributionId(value: any): string | undefined {
    const text = this.sanitizeAttributionText(value, 100);
    return text && ATTRIBUTION_ID_PATTERN.test(text) ? text : undefined;
  }

  private sanitizeAttributionUrl(value: any): string | undefined {
    const text = this.sanitizeAttributionText(value, ATTRIBUTION_MAX_URL_LENGTH);
    if (!text) {
      return undefined;
    }
    try {
      const url = new URL(text);
      return (url.protocol === 'http:' || url.protocol === 'https:') ? text : undefined;
    } catch {
      return undefined;
    }
  }

  private parseAttributionTimestampMs(value: any): number | undefined {
    const text = this.sanitizeAttributionText(value, 20);
    if (!text) {
      return undefined;
    }
    const ms = Number(text);
    return Number.isFinite(ms) && ms > 0 ? ms : undefined;
  }

  private sanitizeAttributionTouchCount(value: any): string | undefined {
    const text = this.sanitizeAttributionText(value, 10);
    return text && ATTRIBUTION_TOUCH_COUNT_PATTERN.test(text) ? text : undefined;
  }

  private sanitizeAttributionData(decoded: any): any {
    if (!decoded || typeof decoded !== 'object' || Array.isArray(decoded)) {
      return null;
    }
    if (decoded.cookie_version !== undefined && ATTRIBUTION_SUPPORTED_VERSIONS.indexOf(String(decoded.cookie_version)) === -1) {
      return null;
    }

    // created_at drives staleness/retention (fixed ~30-day window from original creation,
    // intentionally not extended by later touches - last_touch_date is tracked separately below
    // but does not affect whether the whole cookie is trusted).
    const createdAtMs = this.parseAttributionTimestampMs(decoded.created_at);
    if (decoded.created_at !== undefined) {
      const ageInDays = createdAtMs !== undefined ? (Date.now() - createdAtMs) / (1000 * 60 * 60 * 24) : undefined;
      if (createdAtMs === undefined || ageInDays > ATTRIBUTION_MAX_AGE_DAYS || ageInDays < -1) {
        return null;
      }
    }

    const lastTouchMs = this.parseAttributionTimestampMs(decoded.last_touch_date);
    const useTestFallback = window.localStorage.getItem('attributionTestFallback') === '1';

    return {
      source: this.sanitizeAttributionText(decoded.source, ATTRIBUTION_MAX_TEXT_LENGTH),
      medium: this.sanitizeAttributionText(decoded.medium, ATTRIBUTION_MAX_TEXT_LENGTH),
      campaign: this.sanitizeAttributionText(decoded.campaign, ATTRIBUTION_MAX_TEXT_LENGTH),
      // original_id takes priority over id when present - see attribution_cookie_engineering_notes.md.
      campaign_id: this.sanitizeAttributionId(decoded.original_id) || this.sanitizeAttributionId(decoded.id) || (useTestFallback ? 'CID_1' : undefined),
      landing_page: this.sanitizeAttributionUrl(decoded.landing_page),
      first_touch_date: createdAtMs !== undefined ? decoded.created_at : undefined,
      source_id: this.sanitizeAttributionId(decoded.source_id) || (useTestFallback ? 'SID_1' : undefined),
      // Retained for future use only - nothing downstream consumes these yet, besides original_id feeding campaign_id above.
      original_id: this.sanitizeAttributionId(decoded.original_id),
      original_source_id: this.sanitizeAttributionId(decoded.original_source_id),
      first_touch_by: this.sanitizeAttributionId(decoded.first_touch_by),
      created_by: this.sanitizeAttributionId(decoded.created_by),
      last_touch_by: this.sanitizeAttributionId(decoded.last_touch_by),
      last_touch_date: lastTouchMs !== undefined ? decoded.last_touch_date : undefined,
      touch_count: this.sanitizeAttributionTouchCount(decoded.touch_count),
      signature: this.sanitizeAttributionText(decoded.signature, ATTRIBUTION_MAX_TEXT_LENGTH)
    };
  }

  private getAllAttributionCookieRawValues(): string[] {
    if (!document.cookie) {
      return [];
    }
    const prefix = ATTRIBUTION_COOKIE_NAME + '=';
    return document.cookie
      .split(';')
      .map(part => part.trim())
      .filter(part => part.indexOf(prefix) === 0)
      .map(part => part.substring(prefix.length));
  }

  private readAttributionCookie(): void {
    const rawValues = this.getAllAttributionCookieRawValues();
    if (rawValues.length === 0) {
      console.log(`[${ATTRIBUTION_COOKIE_NAME}] cookie not present, continuing without attribution data`);
      return;
    }

    const candidates: any[] = [];
    for (const rawValue of rawValues) {
      try {
        const decoded = JSON.parse(decodeURIComponent(rawValue));
        const sanitized = this.sanitizeAttributionData(decoded);
        if (sanitized) {
          candidates.push(sanitized);
        }
      } catch (e) {
        console.warn(`[${ATTRIBUTION_COOKIE_NAME}] one of ${rawValues.length} cookie value(s) could not be parsed, skipping it`, e);
      }
    }

    if (candidates.length === 0) {
      console.warn(`[${ATTRIBUTION_COOKIE_NAME}] cookie present but none of the ${rawValues.length} value(s) passed validation, continuing without attribution data`);
      return;
    }

    // When duplicate-named cookies exist (e.g. differing Domain/Path scope), prefer the earliest
    // first-touch among the still-valid candidates, since document.cookie order is browser-determined.
    candidates.sort((a, b) => {
      const aMs = a.first_touch_date ? Number(a.first_touch_date) : Number.POSITIVE_INFINITY;
      const bMs = b.first_touch_date ? Number(b.first_touch_date) : Number.POSITIVE_INFINITY;
      return aMs - bMs;
    });

    this.commonService.attributionData = candidates[0];
    if (candidates.length > 1) {
      console.log(`[${ATTRIBUTION_COOKIE_NAME}] found ${candidates.length} valid cookie value(s), selected earliest first-touch`);
    } else {
      console.log(`[${ATTRIBUTION_COOKIE_NAME}] cookie found and parsed`);
    }
  }

  initializeApp() {


      // AppComponent.isDesktop = (!this.pl.isBrowser && (this.pl.ANDROID || this.pl.IOS)) ? false : true;
      AppComponent.isDesktop = (this.pl.isBrowser && window.innerWidth > this.MOBILE_WIDTH) ? true : false;
      this.apiService.getNmaoConfigurations().subscribe(r=>{
        AppComponent.nmaoConfigs = r;
        var logVar = AppComponent.nmaoConfigs.clientLog.consoleLog;
        if(logVar){
          this.logger.enableLogger();
        }else{
          this.logger.disableLogger();
        }
      });

      this.apiService.getQualificationAssessment().subscribe(r=>{
        AppComponent.QualificationAssessment = r;
      })

      AppComponent.xaAppSubmittedSuccess.subscribe((r: any)=>{
        //create atomic log
        var outputJsonObj = JSON.parse(r.outputJson);
        var XAId =outputJsonObj.OUTPUT.RESPONSE['@loan_id'];
        let atomicLog = {
          appId: XAId,
          didUserOpted: AppComponent.direct_deposit_answer == 'Yes',
          isAtomicReady: AppComponent.direct_deposit_answer != ''
        }
        this.atomicLog.createAtomicLog(atomicLog).subscribe(r=>{})
        
      })

  }


}
